export class ReduxHelpers {
    public static newReducerFromRecordClass(classInstance:any) {
        return function (state = new classInstance(), action:any) {
            if(action && action.reducer && state instanceof action.reducer) {
                const methodame = action.method;
                const fn = state[methodame];
                if (fn) {            
                    return state[methodame](action);
                } else {
                    console.warn('Nie znaleziono metody '+methodame)
                       
                }
            }

            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/Redux/ReduxHelpers.ts